// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","455":"39cb44d2","977":"312a4f8b"}[chunkId] + ".chunk.js";
};